import { customFieldTypeMap } from '../../components/CustomField/CustomField.type';
import { customFieldOptionsMap, IFieldDefinition } from '../../model/types';

const excludedFieldTypes = [
    customFieldOptionsMap.ASSIGNEE,
    customFieldOptionsMap.USER,
    customFieldOptionsMap.MULTI_USER,
    customFieldOptionsMap.TAG
    // With this we do not render multi selects in End user Forms
    //customFieldOptionsMap.MULTI_SELECT,
] as string[];

const isNotAvailableTypeForEndUserForm: (customFieldType: keyof typeof customFieldTypeMap) => boolean = (
    customFieldType
) => excludedFieldTypes.includes(customFieldType);

function notAvailableForEndUserForm(field: Pick<IFieldDefinition, 'type'>) {
    if (!field?.type) return false;
    return !isNotAvailableTypeForEndUserForm(field.type);
}

export { isNotAvailableTypeForEndUserForm, notAvailableForEndUserForm };
